var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_23",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "9.36",
          y: "55.859",
          width: "81.28",
          height: "16.519",
          rx: ".94",
          ry: ".94",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { d: "m62.555,73.064v8.485c0,.489-.291.958-.817,1.4" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { d: "m37.476,71.87v9.678c0,.489.291.958.817,1.4" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m61.738,82.949v2.02c0,2.18-5.253,3.937-11.727,3.937s-11.717-1.757-11.717-3.937v-2.02c1.795,1.485,6.361,2.537,11.717,2.537s9.932-1.052,11.727-2.537Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "61.738", y1: "82.949", x2: "61.738", y2: "82.545" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "38.293", y1: "82.949", x2: "38.293", y2: "82.545" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m49.999,45.45c-5.506,0-10.27-.846-12.554-2.077-.009,0-.009-.009-.019-.009s-.009-.009-.019-.009",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m62.503,43.355c-.009,0-.009.009-.019.009s-.009.009-.019.009c-2.283,1.231-7.047,2.077-12.554,2.077",
        },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "38.601 38.347 37.427 43.074 37.427 56.454" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "62.484 56.454 62.484 43.121 61.31 38.347" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m61.312,38.353c0,1.09-5.055,1.983-11.313,1.992h-.085c-6.258-.009-11.313-.902-11.313-1.992s5.055-1.983,11.313-1.992h.085c6.258.009,11.313.902,11.313,1.992Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { d: "m37.566,73.064v8.485c0,.489-.291.958-.817,1.4" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { d: "m12.487,71.87v9.678c0,.489.291.958.817,1.4" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m36.749,82.949v2.02c0,2.18-5.253,3.937-11.727,3.937s-11.717-1.757-11.717-3.937v-2.02c1.795,1.485,6.361,2.537,11.717,2.537s9.932-1.052,11.727-2.537Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "36.748", y1: "82.949", x2: "36.748", y2: "82.545" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "13.304", y1: "82.949", x2: "13.304", y2: "82.545" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m25.01,45.45c-5.506,0-10.27-.846-12.554-2.077-.009,0-.009-.009-.019-.009s-.009-.009-.019-.009",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m37.514,43.355c-.009,0-.009.009-.019.009s-.009.009-.019.009c-2.283,1.231-7.047,2.077-12.554,2.077",
        },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "13.612 38.347 12.438 43.074 12.438 56.454" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "37.495 56.454 37.495 43.121 36.32 38.347" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m36.323,38.353c0,1.09-5.055,1.983-11.313,1.992h-.085c-6.258-.009-11.313-.902-11.313-1.992s5.055-1.983,11.313-1.992h.085c6.258.009,11.313.902,11.313,1.992Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { d: "m87.581,73.064v8.485c0,.489-.291.958-.817,1.4" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { d: "m62.502,71.87v9.678c0,.489.291.958.817,1.4" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m86.764,82.949v2.02c0,2.18-5.253,3.937-11.727,3.937s-11.717-1.757-11.717-3.937v-2.02c1.795,1.485,6.361,2.537,11.717,2.537s9.932-1.052,11.727-2.537Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "86.764", y1: "82.949", x2: "86.764", y2: "82.545" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "63.32", y1: "82.949", x2: "63.32", y2: "82.545" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m75.025,45.45c-5.506,0-10.27-.846-12.554-2.077-.009,0-.009-.009-.019-.009s-.009-.009-.019-.009",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m87.529,43.355c-.009,0-.009.009-.019.009s-.009.009-.019.009c-2.283,1.231-7.047,2.077-12.554,2.077",
        },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "63.627 38.347 62.453 43.074 62.453 56.454" },
      }),
      _c("polyline", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { points: "87.51 56.454 87.51 43.121 86.336 38.347" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m86.339,38.353c0,1.09-5.055,1.983-11.313,1.992h-.085c-6.258-.009-11.313-.902-11.313-1.992s5.055-1.983,11.313-1.992h.085c6.258.009,11.313.902,11.313,1.992Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }